<template lang="pug">
  .container
    .columns.is-vcentered.is-mobile(v-show="origen == 3")
      .column.is-6
        label.label ¿Es la primera vez que nos visita?
      .column.is-6
        input#cvisExtY.is-checkradio.is-dark(type='radio' value="1" v-model='isPrimeraVez')
        label.is-size-6(for='cvisExtY') SI
        input#cvisExtN.is-checkradio.is-dark(type='radio' value="0" v-model='isPrimeraVez')
        label.is-size-6(for='cvisExtN') No
    .columns.is-vcentered.is-mobile(v-show="isPrimeraVez === '0'")
      .column.is-4
        label.label 
          | Escriba y seleccione su nombre del listado
      .column.is-8
        TypeaheadUsuario(:options="empleados" :optionSelect="empleadoSel" v-model="empleadoSel" :isDisabled="isDisabled")
    .columns.is-vcentered.is-mobile(v-show="isPrimeraVez === '1'")
      .column.is-4
        label.label 
          | Escriba su nombre completo
      .column.is-8
        .field
          .control
            input.input.is-dark(
              type='text', 
              placeholder='Nombre completo',
              v-model="nombreExterno"
              required
            )
    //.columns.is-mobile
      .column.is-2
        label.label Temperatura
      .column.is-4
        .field
          .control
            input.input.is-dark(
              type='number', 
              min="35"
              max="42"
              placeholder='35°C',
              v-model="temperatura",
            )
    .columns.us-mobile.is-centered(v-show="origen == 3")
      .column.is-4
        label.label 
          | Persona a la que visita
      .column.is-8
        TypeaheadUsuario(:options="empleadosAll" :optionSelect="personaVisita" v-model="personaVisita")
    //.columns.is-mobile.is-centered
      .column.is-12
        div.container-pregunta
          div.container-pregunta-text
            div
              b ¿Haz presentado algún síntoma relacionado con el COVID 19 en los últimos cinco días?
          div.container-pregunta-answers
            div.container-pregunta-button
              div.pregunta-button.icon(@click="showForm(false)" :class="!verFormulario ? 'btn-green' : ''")
                span.icon
                  i.fas.fa-smile-beam
              div.pregunta-button.text
                b No
            div.container-pregunta-button
              div.pregunta-button.icon(@click="showForm(true)" :class="verFormulario ? 'btn-red' : ''")
                span.icon
                  i.fas.fa-sad-tear
              div.pregunta-button.text
                b Si
    .columns.is-mobile.is-vcentered(v-show='verFormulario')
      .column.is-12
        div.container-pregunta
          div.container-pregunta-text
            div
              b ¿Fiebre mayor a 37.5°C?
          div.container-pregunta-answers
            div.container-pregunta-button
              div.pregunta-button.icon(@click="fiebre=0" :class="fiebre ==0 ? 'btn-green' : ''")
                span.icon
                  i.fas.fa-smile-beam
              div.pregunta-button.text
                b No
            div.container-pregunta-button
              div.pregunta-button.icon(@click="fiebre=1" :class="fiebre ==1 ? 'btn-red' : ''")
                span.icon
                  i.fas.fa-sad-tear
              div.pregunta-button.text
                b Si
    .columns.is-mobile.is-vcentered(v-show='verFormulario')
      .column.is-12
        div.container-pregunta
          div.container-pregunta-text
            div
              b ¿Tos Seca?
          div.container-pregunta-answers
            div.container-pregunta-button
                div.pregunta-button.icon(@click="tos=0" :class="tos ==0 ? 'btn-green' : ''")
                  span.icon
                    i.fas.fa-smile-beam
                div.pregunta-button.text
                  b No
            div.container-pregunta-button
              div.pregunta-button.icon(@click="tos=1" :class="tos ==1 ? 'btn-red' : ''")
                span.icon
                  i.fas.fa-sad-tear
              div.pregunta-button.text
                b Si
    .columns.is-mobile.is-vcentered(v-show='verFormulario')
      .column.is-12
        div.container-pregunta
          div.container-pregunta-text
            div
              b ¿Dolor de Cabeza?
          div.container-pregunta-answers
            div.container-pregunta-button
                div.pregunta-button.icon(@click="dolorC=0" :class="dolorC ==0 ? 'btn-green' : ''")
                  span.icon
                    i.fas.fa-smile-beam
                div.pregunta-button.text
                  b No
            div.container-pregunta-button
              div.pregunta-button.icon(@click="dolorC=1" :class="dolorC ==1 ? 'btn-red' : ''")
                span.icon
                  i.fas.fa-sad-tear
              div.pregunta-button.text
                b Si
    .columns.is-mobile.is-vcentered(v-show="verFormulario")
      .column.is-
        div.container-pregunta
          div.container-pregunta-text
            div
              b ¿Escurrimiento Nasal?
          div.container-pregunta-answers
            div.container-pregunta-button
                div.pregunta-button.icon(@click="escurrimiento=0" :class="escurrimiento ==0 ? 'btn-green' : ''")
                  span.icon
                    i.fas.fa-smile-beam
                div.pregunta-button.text
                  b No
            div.container-pregunta-button
              div.pregunta-button.icon(@click="escurrimiento=1" :class="escurrimiento ==1 ? 'btn-red' : ''")
                span.icon
                  i.fas.fa-sad-tear
              div.pregunta-button.text
                b Si
    .columns.is-mobile.is-vcentered(v-show="verFormulario")
      .column.is-
        div.container-pregunta
          div.container-pregunta-text
            div
              b ¿Perdida del olfato ó gusto?
          div.container-pregunta-answers
            div.container-pregunta-button
                div.pregunta-button.icon(@click="olfatoGusto=0" :class="olfatoGusto ==0 ? 'btn-green' : ''")
                  span.icon
                    i.fas.fa-smile-beam
                div.pregunta-button.text
                  b No
            div.container-pregunta-button
              div.pregunta-button.icon(@click="olfatoGusto=1" :class="olfatoGusto ==1 ? 'btn-red' : ''")
                span.icon
                  i.fas.fa-sad-tear
              div.pregunta-button.text
                b Si
    .columns.is-mobile.is-vcentered(v-show="verFormulario")
      .column.is-
        div.container-pregunta
          div.container-pregunta-text
            div
              b ¿Dolor Muscular?
          div.container-pregunta-answers
            div.container-pregunta-button
                div.pregunta-button.icon(@click="dolorM=0" :class="dolorM ==0 ? 'btn-green' : ''")
                  span.icon
                    i.fas.fa-smile-beam
                div.pregunta-button.text
                  b No
            div.container-pregunta-button
              div.pregunta-button.icon(@click="dolorM=1" :class="dolorM ==1 ? 'btn-red' : ''")
                span.icon
                  i.fas.fa-sad-tear
              div.pregunta-button.text
                b Si
    .columns.is-mobile.is-vcentered(v-show="verFormulario")
      .column.is-
        div.container-pregunta
          div.container-pregunta-text
            div
              b ¿Ojos Irritados?
          div.container-pregunta-answers
            div.container-pregunta-button
                div.pregunta-button.icon(@click="ojosI=0" :class="ojosI ==0 ? 'btn-green' : ''")
                  span.icon
                    i.fas.fa-smile-beam
                div.pregunta-button.text
                  b No
            div.container-pregunta-button
              div.pregunta-button.icon(@click="ojosI=1" :class="ojosI ==1 ? 'btn-red' : ''")
                span.icon
                  i.fas.fa-sad-tear
              div.pregunta-button.text
                b Si
    .columns.is-mobile.is-vcentered(v-show="verFormulario")
      .column.is-12
        div.container-pregunta
          div.container-pregunta-text
            div
              b ¿Dolor de Garganta?
          div.container-pregunta-answers
            div.container-pregunta-button
                div.pregunta-button.icon(@click="dolorG=0" :class="dolorG ==0 ? 'btn-green' : ''")
                  span.icon
                    i.fas.fa-smile-beam
                div.pregunta-button.text
                  b No
            div.container-pregunta-button
              div.pregunta-button.icon(@click="dolorG=1" :class="dolorG ==1 ? 'btn-red' : ''")
                span.icon
                  i.fas.fa-sad-tear
              div.pregunta-button.text
                b Si
    .columns.is-mobile.is-vcentered(v-show="verFormulario")
      .column.is-12
        div.container-pregunta
          div.container-pregunta-text
            div
              b ¿Dificultad Respiratoria?
          div.container-pregunta-answers
            div.container-pregunta-button
                div.pregunta-button.icon(@click="dificultadR=0" :class="dificultadR ==0 ? 'btn-green' : ''")
                  span.icon
                    i.fas.fa-smile-beam
                div.pregunta-button.text
                  b No
            div.container-pregunta-button
              div.pregunta-button.icon(@click="dificultadR=1" :class="dificultadR ==1 ? 'btn-red' : ''")
                span.icon
                  i.fas.fa-sad-tear
              div.pregunta-button.text
                b Si
    .columns.is-mobile.is-vcentered(v-show="verFormulario")
      .column.is-12
        div.container-pregunta
          div.container-pregunta-text
            div
              b 
                | ¿Haz estado en contacto con alguna persona con los síntomas mencionados?
          div.container-pregunta-answers
            div.container-pregunta-button
                div.pregunta-button.icon(@click="contactoS=0" :class="contactoS ==0 ? 'btn-green' : ''")
                  span.icon
                    i.fas.fa-smile-beam
                div.pregunta-button.text
                  b No
            div.container-pregunta-button
              div.pregunta-button.icon(@click="contactoS=1" :class="contactoS ==1 ? 'btn-red' : ''")
                span.icon
                  i.fas.fa-sad-tear
              div.pregunta-button.text
                b Si
    .columns.is-mobile.is-vcentered(v-show="verFormulario")
      .column.is-12
        div.container-pregunta
          div.container-pregunta-text
            div
            b ¿Haz estado en contacto con algún caso de Covid 19?
          div.container-pregunta-answers
            div.container-pregunta-button
                div.pregunta-button.icon(@click="contactoC19=0" :class="contactoC19 ==0 ? 'btn-green' : ''")
                  span.icon
                    i.fas.fa-smile-beam
                div.pregunta-button.text
                  b No
            div.container-pregunta-button
              div.pregunta-button.icon(@click="contactoC19=1" :class="contactoC19 ==1 ? 'btn-red' : ''")
                span.icon
                  i.fas.fa-sad-tear
              div.pregunta-button.text
                b Si
    .columns(v-show="datosFaltantes.length > 0")
      .notification
        button.delete(@click="deleteNotifications")
        .field.is-grouped.is-grouped-multiline
          .control(v-for="datosF in datosFaltantes")
            .tags
              span.tag.is-danger.is-light {{ datosF }}
    .columns.is-mobile
      .column.is-offset-2.is-8
        a.button.is-black.is-rounded.is-block(@click="checkForm")
          | Registrar
</template>

<script>
  import TypeaheadUsuario from "@/components/usuarios_Componentes/componentes/TypeaheadUsuario.vue"
  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'
  import { Spanish } from "flatpickr/dist/l10n/es.js"
  import { mapState } from 'vuex'

  import moment from 'moment'
  export default {
    name: 'FormAsistencia',
    components: { TypeaheadUsuario, flatPickr },
    props: {
      empleados: {
        type: Array,
        default: []
      },
      empleadosAll: {
        type: Array,
        default: []
      },
      origen: {
        type: Number,
        default: 0
      },
    },
    data() {
      return {
        empleadoSel: {},
        fecha: null,
        temperatura: 36,
        firma: null,
        fiebre: 0,
        tos: 0,
        dolorC: 0,
        escurrimiento: 0,
        dolorM: 0,
        ojosI: 0,
        dolorG: 0,
        dificultadR: 0,
        contactoS: 0,
        contactoC19: 0,
        olfatoGusto: 0,
        isDisabled: false,
        datosFaltantes: [],
        isEmpleado: true,
        isPrimeraVez: '0',
        nombreExterno: '',
        verFormulario: false,
        personaVisita: {},
      }
    },
    watch: {
      nombreExterno () {
        if (this.isPrimeraVez) {
          this.empleadoSel = {
            nombre: this.nombreExterno
          }
        } else {
          this.empleadoSel = {}
        }
      },
      empleados () {
        this.checkEmpleado()
      },
      verFormulario () {
        if (!this.verFormulario) {
          this.fiebre = 0
          this.tos = 0
          this.dolorC = 0
          this.escurrimiento = 0
          this.olfatoGusto = 0
          this.dolorM = 0
          this.ojosI = 0
          this.dolorG = 0
          this.dificultadR = 0
          this.contactoS = 0
          this.contactoC19 = 0
        }
      },
    },
    methods: {
      checkForm() {
        this.datosFaltantes = []
        if (Object.keys(this.empleadoSel).length > 0 && this.temperatura &&
        this.fiebre !== null && this.tos !== null && this.dolorC !== null && 
        this.escurrimiento !== null && this.olfatoGusto !== null && this.dolorM !== null && this.ojosI !== null && 
        this.dolorG !== null && this.dificultadR !== null && this.contactoS !== null && 
        this.contactoC19 !== null ) {
          this.sendForm()
        } else {
          if (Object.keys(this.empleadoSel).length == 0) {
            this.datosFaltantes.push('El usuario es requerido.')
          }
          
          if (!this.temperatura) {
            this.datosFaltantes.push('La temperatura es requerido.')
          }
          
          if (this.fiebre === null) {
            this.datosFaltantes.push('El sintoma de fiebre es requido.')
          }

          if (this.tos === null) {
            this.datosFaltantes.push('El sintoma de tos es requido.')
          }

          if (this.dolorC === null) {
            this.datosFaltantes.push('El sintoma de dolor de Cuerpo es requido.')
          }

          if (this.escurrimiento === null) {
            this.datosFaltantes.push('El sintoma de escurrimiento Nasal es requido.')
          }

          if (this.olfatoGusto === null) {
            this.datosFaltantes.push('El sintoma de pérdida de olfato o gusto es requido.')
          }

          if (this.dolorM === null) {
            this.datosFaltantes.push('El sintoma de dolor Muscular es requido.')
          }

          if (this.ojosI === null) {
            this.datosFaltantes.push('El sintoma de ojos Irritados es requido.')
          }

          if (this.dolorG === null) {
            this.datosFaltantes.push('El sintoma de dolor de Garganta es requido.')
          }

          if (this.dificultadR === null) {
            this.datosFaltantes.push('El sintoma de dificultad Respiratoria es requido.')
          }

          if (this.contactoS === null) {
            this.datosFaltantes.push('Indicar si tuvo contacto con alguna persona con síntomas es requido.')
          }
          console.log(this.contactoC19 === null)
          if (this.contactoC19 === null) {
            this.datosFaltantes.push('Indicar si tuvo contacto con alguna persona con Covid 19 es requido.')
          }

        }
      },
      checkEmpleado () {
        this.empleados.forEach(empleado => {
          if (empleado.nombre === this.userLogin.nombre) {
            this.empleadoSel = empleado
          }
        })
      },
      sendForm () {
        let fechaReg = moment().format('YYYY-MM-DD HH:mm:ss')
        if (this.temperatura < 35 ) {
          this.temperatura = 35
        }
        if (this.temperatura > 45 ) {
          this.temperatura = 45
        }

        let myObj = {
          nombre: this.empleadoSel.nombre,
          idEmp: this.empleadoSel.id,
          temperatura: Number(this.temperatura),
          fiebre: this.fiebre,
          tos: this.tos,
          dolorC: this.dolorC,
          escurrimiento: this.escurrimiento,
          olfatoGusto: this.olfatoGusto,
          dolorM: this.dolorM,
          ojosI: this.ojosI,
          dolorG: this.dolorG,
          dificultadR: this.dificultadR,
          contactoS: this.contactoS,
          contactoC19: this.contactoC19,
          primeraVez: this.isPrimeraVez === '1' ? true : false,
          personaVisita: Object.keys(this.personaVisita).length > 1 ? this.personaVisita.id : 0,
        }
        this.$emit('saveVisita', myObj)
      },
      deleteNotifications () {
        this.datosFaltantes = []
      },
      showForm(answer) {
        this.verFormulario = answer
        this.$emit('showFormulario', answer)
      },
    },
    created () {
      this.origen == 3 ? this.isPrimeraVez = '1' : this.isPrimeraVez = '0'
    },
    mounted () {
      this.checkEmpleado()
    },
    
    computed: {
      ...mapState(['logueado', 'userLogin'])
    },
  }
</script>

<style scoped>
  .container-pregunta {
    display: flex;
    flex-direction: column;
    align-content: center;
    border: 2px solid #54545c;
    border-radius: 10px;
  }
  .container-pregunta-text {
    display: flex;
    justify-content: center;
    align-content: center;
    margin-top: 15px;
    margin-bottom: 20px;
  }
  .container-pregunta-text div{
    display: flex;
    align-items: center;
  }

  .container-pregunta-answers {
    display: flex;
    justify-content: space-evenly;
    align-content: center;
  }

  .pregunta-button.icon {
    font-size: 3rem;
    margin-top: 5px;
    margin-bottom: 10px;
    cursor: pointer;
    color: #4a4a4a;
  }
  
  .pregunta-button.icon.btn-green {
    color: #48c774;
  }

  .pregunta-button.icon.btn-red {
    color: #d3142c;
  }
</style>


// WEBPACK FOOTER //
// src/components/visitas_Componentes/components/FormVisita.vue